import { fetchPhr } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { FetchPHRResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from './client';

/**
 * Fetch PHR for a user. Returns response.data directly.
 */
export async function fetchPhrByUserId(
  userId: string,
  signal?: AbortSignal
): Promise<FetchPHRResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPhr(userId, config);
  return response.data;
}
